/**
 * Breakpoint values used for responsive style rendering.
 */

/**
 * @type {['40em', '52em', '64em']}
 */
export var breakpoints = ['40em', '52em', '64em'];